/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import * as Sentry from '@sentry/react';

import { getUserId } from '@fai/friendli-suite/features/routes/loaders/apis/user';

export const setSentryUser = async () => {
  const id = await getUserId();

  if (id) {
    Sentry.setUser({ id });
  }

  return null;
};
